module.exports = __webpack_public_path__ + "img/Dantam Hair 42.00cee1f8.jpg";